import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';

const Loading = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const tr = (ko, en) => localize(i18n.resolvedLanguage || i18n.language, { ko, en });

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/seb-test/result');
        }, 2500);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="loading-container">
            <div className="loader-wrapper">
                <div className="pulse"></div>
                <div className="spinner"></div>
            </div>
            <h2 className="loading-text">{tr('데이터 분석 중...', 'Analyzing Data...')}</h2>
            <p className="loading-sub">{tr('S-E-F 지표를 조합하고 있습니다.', 'Combining the S-E-F indicators.')}</p>

            <style jsx>{`
                .loading-container {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: #0f172a;
                    color: white;
                }

                .loader-wrapper {
                    position: relative;
                    width: 100px;
                    height: 100px;
                    margin-bottom: 2rem;
                }

                .pulse {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background: rgba(59, 130, 246, 0.2);
                    border-radius: 50%;
                    animation: pulse 2s infinite;
                }

                .spinner {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border: 4px solid transparent;
                    border-top-color: #3b82f6;
                    border-left-color: #8b5cf6;
                    border-radius: 50%;
                    animation: spin 1.5s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                @keyframes pulse {
                    0% { transform: scale(1); opacity: 0.2; }
                    50% { transform: scale(1.5); opacity: 0; }
                    100% { transform: scale(1); opacity: 0.2; }
                }

                .loading-text {
                    font-size: 1.5rem;
                    font-weight: 700;
                    margin-bottom: 0.5rem;
                    background: linear-gradient(to right, #fff, #94a3b8);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .loading-sub {
                    color: #64748b;
                    font-size: 1rem;
                }
            `}</style>
        </div>
    );
};

export default Loading;
